<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Sprint
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="control-label">Title</label>
                                <input
                                    name="title"
                                    type="text"
                                    class="form-control"
                                    v-model="sprint.title"
                                    v-validate="'required'" />

                                <help-block field="title"/>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="control-label">Start Date</label>
                                <flat-pickr
                                v-model="sprint.start_date"
                                class="form-control"
                                placeholder="DD/MM/YYYY"
                                :config="{dateFormat:'Y-m-d', altFormat: 'd/m/Y', altInput: true}"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="control-label">End Date</label>
                                <flat-pickr
                                v-model="sprint.end_date"
                                class="form-control"
                                placeholder="DD/MM/YYYY"
                                :config="{dateFormat:'Y-m-d', altFormat: 'd/m/Y', altInput: true}"></flat-pickr>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button v-if="sprint.id" type="button" class="btn btn-link text-danger px-0" @click="handleDelete">Delete Sprint</button>
                        <div class="ms-auto">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                            <c-button @click="handleSave" class="btn btn-rounded btn-primary">Save</c-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import { cloneDeep } from 'lodash'
    import { http, notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { LaddaButton } from 'components/form/input'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },

        components: {
            LaddaButton,
            Multiselect
        },

        props: ['editSprint'],

        data() {
            return {
                sprint: {}
            }
        },

        computed: {
            ...mapState('yodizproject', {
                project: 'single'
            })
        },

        mounted () {

            this.addEventListener('open', () => {
                this.sprint = cloneDeep(this.editSprint)
            });
        },

        methods: {
            ...mapActions("yodizproject/sprints", {addSprint: 'addListObject', updateSprint: 'updateListObject', deleteSprint: 'deleteListObject'}),
            async handleSave() {
                if (this.sprint.id) {
                    await this.updateSprint({id: this.sprint.id, payload: this.sprint})
                    this.close()
                } else {
                    await this.addSprint({payload: this.sprint})
                    this.close()
                }
            },

            async handleDelete() {
                var that = this;

                this.$swal({
                    title: 'Confirm Delete', 
                    html: 'Are you sure you want to delete Sprint #'+this.sprint.title + '?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    }).then(function() {
                        that.deleteSprint({id: that.sprint.id}).then(() => {
                            //notify.success('New activity log successfully created.')
                            that.close()
                        });
                });
            }
            
        }
    }
</script>